<template>
  <div>

  </div>
</template>

<script>
import { EventDispatcher } from 'three'
import O3DNode from '../../Core/O3DNode'
export default {
  mixins: [
    O3DNode
  ],
  mounted () {
    class GameNPC extends EventDispatcher {
      constructor ({ o3d, onLoop, chroma }) {
        super()
        this.onLoop = onLoop
        this.chroma = chroma
        this.o3d = o3d
        this.size = {
          x: 16 / 2,
          y: 20,
          z: 16 / 2,
        }
        this.moodType = 'fighting'
        this.chars = ['swat', 'glassman', 'suzie']
        this.useCharacter = 'swat'
        // this.useCharacter = this.chars[Math.floor(Math.random() * this.chars.length)]

        this.done = this.setup()
      }

      async setup () {
        // let base = new BaseMocker({ o3d: this.o3d, onLoop: this.onLoop, chroma: this.chroma })
        let Characeter = require('./EventChar').Character
        let char = new Characeter({ base: this, isNPC: true })

        await char.waitForSetup().then(() => {
          char.actor.position.y += 20
          // char.actor.position.x += 15 / 2
          this.o3d.add(char.actor)

          char.act({ name: 'Ymca Dance' })
        })
      }
    }
    new GameNPC({
      o3d: this.o3d,
      onLoop: this.onLoop,
      chroma: this.chroma,
    })
  }
}
</script>

<style>

</style>